var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-detail"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/feedback/bg.jpg")}}),_c('div',{staticClass:"toast"},[_c('span',[_vm._v("正在跳转中...")])])])
}]

export { render, staticRenderFns }